import { deleteCookie, getJsonCookieValue, getSuffix, setSharedJsonCookie } from '../cookie';
/**
 * Navn på cookie som lagrer data om hvilke undersøkelser brukeren har takket ja eller nei til å delta i.
 */
export const SURVEYS_COOKIE_NAME = 'hn-surveys';
/**
 * Slett undersøkelse med gitt ID fra cookie etter et visst antall dager, for å unngå at cookie blir for stor.
 */
const MAX_AGE_MS = 60 * 60 * 24 * 180 * 1000; // 180 dager i millisekunder
/**
 * Returnerer navnet på cookien som lagrer data om hvilke undersøkelser brukeren har takket ja eller nei til å delta i.
 *
 * @returns Navn på cookie
 */
export const getSurveysCookieName = () => getSuffix(SURVEYS_COOKIE_NAME);
/**
 * Henter innholdet i cookie som lagrer data om hvilke undersøkelser brukeren har takket ja eller nei til å delta i.
 *
 * @returns Innhold i cookie eller undefined hvis cookie ikke finnes eller er ugyldig
 */
export const getSurveysCookie = () => {
    const value = getJsonCookieValue(SURVEYS_COOKIE_NAME);
    if (value) {
        return value;
    }
    deleteCookie(getSurveysCookieName());
};
/**
 * Legg til undersøkelse med gitt ID i cookie for å indikere at brukeren har takket ja eller nei til å delta i undersøkelsen.
 *
 * Fjerner også undersøkelser som er eldre enn MAX_AGE_MS for å unngå at cookie blir for stor.
 *
 * @param surveyId ID til undersøkelse som bruker har takket ja eller nei til
 */
export const setSurveysCookie = (surveyId) => {
    const surveys = getSurveysCookie() || {};
    const now = Date.now();
    for (const [id, timestamp] of Object.entries(surveys)) {
        if (now - timestamp > MAX_AGE_MS) {
            delete surveys[id];
        }
    }
    const surveyCookieName = getSurveysCookieName();
    setSharedJsonCookie(surveyCookieName, { ...surveys, [surveyId]: Date.now() });
};
